<div
  *appHasPermission="{
    permissions: [permissions.allPermissions.DASHBOARD_READ],
  }"
  class="assetAdminContainer"
>
  <app-asset-hierarchy
    *appHasPermission="{
      permissions: [permissions.allPermissions.ASSET_HIERARCHY_READ],
    }"
    (assetClicked)="selectAsset($event)"
    [initialSelectedAssetId]="initialSelectedAssetId"
    [initialSelectedAssetType]="initialSelectedAssetType"
  ></app-asset-hierarchy>
  <router-outlet style="display: none"></router-outlet>
</div>
